// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"a4b38e37","232":"144626e9","242":"cf9aa23b","337":"dc66c575","476":"797cfd06","597":"ba727e50","703":"8a260dc4","706":"0ff432e6","738":"4a619360","882":"a94cf49a","971":"f52db7b6","993":"6a41374b"}[chunkId] + ".chunk.js";
};